import "../css/toggle.css";
import { useState } from "react";
import consts from "../consts.js";

function Toggle({ language, setLanguage }) {
  const [otherLanguage, setOtherLanguage] = useState(() => {
    return language === consts.ENGLISH ? consts.ESPANOL : consts.ENGLISH;
  });
  function handleClick() {
    if (otherLanguage === consts.ESPANOL) {
      setOtherLanguage(consts.ENGLISH);
      setLanguage(consts.ESPANOL);
    } else {
      setOtherLanguage(consts.ESPANOL);
      setLanguage(consts.ENGLISH);
    }
  }
  return (
    <div className="Toggle" onClick={handleClick}>
      {otherLanguage}
    </div>
  );
}

export default Toggle;
